var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Ver Detalle de la SIM" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [_c("h1", [_vm._v(_vm._s(_vm.serieNumeroSeleccionado))])]
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("InventarioSimForm", {
        attrs: {
          modoVer: true,
          isEditar: true,
          serieNumeroSeleccionado: _vm.serieNumeroSeleccionado,
          simestadolistSeleccionado: _vm.simestadolistSeleccionado
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }